// @ts-nocheck
import React, {useEffect, useMemo} from "react";
import { ApplicationRoutes } from "./routes";
import { Route, Routes } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import StoreService from "./services/StoreService";
import ProtectedRouteComponent from "./components/ProtectedRouteComponent";
import ScrollToTop from "./utils/ScrollToTop";
import Sidemenu from "./components/BarsOverlay/BarsOverlayComponent";
import NotificationSelector from "./NotificationSelector";
import { getMenuItems } from "./services/LabService";
import LoaderComponent from "./components/Loader/LoaderComponent";
import { useAppSelector } from "./services/StoreHooks";
import KeycloakService from "./services/KeycloakService";
import { adminCategoryDocDropDown } from "./services/FortificationService";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from "dayjs";
import 'dayjs/locale/hi'
import "dayjs/locale/si"; // Import Sinhalese
import "dayjs/locale/ta"; // Import Tamil
import i18n from "./i18n";

const store = StoreService;

function App() {
  const loaderStatus = useAppSelector((state) => state.loaderStatus);

  const { t : translate, i18n } = useTranslation();
  const [language, setLanguage] = React.useState(localStorage.getItem('preferredLang') || sessionStorage.getItem('langFromKcToken') || 'en')
  // const [language, setLanguage] = React.useState('en')
  dayjs.locale(language);
  
  useEffect(()=>{    
    i18n.changeLanguage(language);
  }, [language])

  // debugger;

  const searchParams = new URLSearchParams(window.location.search);
    const didRedirectToHere = searchParams.get('redirected');

    const userDetails = KeycloakService.getUserDetail()
    const isMonitor = userDetails?.isMonitor;


  const [menuDetails, setMenuDetails] = React.useState([]);
  const [loader, setLoader] = React.useState(false);

  const dispatch = useDispatch();

  const assignNodeId = (nodeArr, initialId, categoryDetail) => {
    let currId;
    if (initialId) currId = initialId;
    else currId = 0;
    return {
      entityStates: nodeArr.map((ele) => {
        if (ele.entityStates) {
          const { entityStates, id } = assignNodeId(
            ele.entityStates, 
            currId, 
            {
              categoryId: ele.categoryId,
              categoryName: ele.categoryName
            }
          );
          ele.entityStates = entityStates;
          currId = id;
        }
        currId++;
        return { 
          ...ele, nodeId: currId.toString(), 
          categoryId: ele?.categoryId || categoryDetail?.categoryId
        };
      }),
      id: currId,
    };
  };

  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const translationToastMap = {
    'en':"Please update your password",
    "si":"කරුණාකර ඔබේ මුරපදය යාවත්කාලීන කරන්න",
    "ta":"உங்கள் கடவுச்சொல்லை புதுப்பிக்கவும்"
  }

  useMemo(()=>{
    if(!userDetails.isPasswordUpdated){
      dispatchNotification("warning", [translationToastMap[language]]);
    }
  },[])

  const fetchData = async () => {

    let categoryNameToIdMapRedux = {};

    const categories = await adminCategoryDocDropDown();
    if (categories.status === 200) {
        if (categories.data.data) {
            dispatch({
                type: "STORE_CATEGORIES",
                data: categories.data.data,
            });

            categoryNameToIdMapRedux = categories.data.data.reduce(
              (acc, current) => {
                acc[current.name] = current.id.toString();
                return acc;
              },
              {}
            )
         
        }
    }


    const menuData = await getMenuItems();
    const actionNameMap = {};
    if (menuData?.data) {
      if(menuData?.data.length > 0) {
      menuData.data?.forEach((menuItem)=> {
        menuItem.entityStates.forEach(entityState => {
          actionNameMap[entityState.name] = entityState.displayName;
        });
      })
      sessionStorage.setItem('menuItemDisplayMap', JSON.stringify(actionNameMap));
      const refactoredMenuData = assignNodeId(menuData.data);
      setMenuDetails(() => refactoredMenuData.entityStates);
      } else{
        isMonitor && setMenuDetails(["temp"]) //setting menuDetails as non-empty when logging in from supermonitor
      } 
    }
    setLoader(false);
  };

  useEffect(() => {
    setLoader(true);
    fetchData();
  }, []);

  return (
    <>
    {
    loader 
    // || 
    // !menuDetails?.length 
    ? (
      <LoaderComponent />
    ) : (
    
      <>
      {(menuDetails.length > 0) && 
      <>
      <Sidemenu menuDetails={menuDetails} redirected={didRedirectToHere} language={language} setLanguage={setLanguage}/>
      <div className={`all-content-backdrop ${loaderStatus.showLoader ? 'no-overflow' : ''}`}>
        <div className={didRedirectToHere ? "main-content-container-nosidebar" : "main-content-container"}>
        {loaderStatus.showLoader ? <LoaderComponent loaderType="spinner" /> : ''}
          <NotificationSelector>
            <ScrollToTop>
              <Routes>
                {ApplicationRoutes.map((route) => (
                  <Route
                    key={route.key}
                    path={route.path + "/*"}
                    element={
                      <ProtectedRouteComponent menuDetails={menuDetails} isMonitor={isMonitor}>
                        <route.component />
                      </ProtectedRouteComponent>
                    }
                  />
                ))}
              </Routes>
            </ScrollToTop>
          </NotificationSelector>
        </div> 
      </div>
      </>}

        </>
        
    )}
    </>
  );
}

export default App;
